import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class GeneralEventsService {
  public _isSideBarOpen$ = new BehaviorSubject(true);

  public get sideBarOpen$(): Observable<boolean> {
    return this._isSideBarOpen$.asObservable();
  }

  public toggleSidebar(value: boolean): void {
    this._isSideBarOpen$.next(value);
  }
}
